import { FC, PropsWithChildren, useLayoutEffect, useRef, useState } from 'react';

import { TooltipHover, Text } from '@hh.ru/magritte-ui';

const CollapsedTextWithHint: FC<PropsWithChildren> = ({ children }) => {
    const [isHoverExist, setHoverExist] = useState(false);

    const containerRef = useRef<HTMLDivElement>(null);

    useLayoutEffect(() => {
        if (containerRef.current && containerRef.current.scrollHeight > containerRef.current.offsetHeight) {
            setHoverExist(true);
        }
    }, []);

    return (
        <>
            {isHoverExist && (
                <TooltipHover activatorRef={containerRef} placement="top-center">
                    {children}
                </TooltipHover>
            )}
            <Text typography="subtitle-3-semibold" maxLines={1}>
                <div ref={containerRef}>{children}</div>
            </Text>
        </>
    );
};

export default CollapsedTextWithHint;
